import { h } from 'preact';
import * as BaseComp from 'components/shared/articleThumb/articleThumb.js';
import { findInVNode } from 'utils/vnode';
import Store from 'store/store';
import s from 'components/shared/articleThumb/articleThumb.sss';

import { Link } from 'components/core/link/link.js';

export default class ArticleThumb extends BaseComp.default {
	constructor(props) {
		super(props);
		this.onContentClick = this.onContentClick.bind(this);
		this.observerCallback = this.observerCallback.bind(this);
	}

	componentDidMount() {
		const pagesWithObserver = ['successStories', 'jobListings'];
		const activePage = Store.get().activePage.id;
		if (pagesWithObserver.includes(activePage)) {
			this.observer = new IntersectionObserver(this.observerCallback, { threshold: [1] });
			this.observer.observe(this.$container);
		}
	}

	componentWillUnmount() {
		if (this.observer) {
			this.observer.unobserve(this.$container);
			this.observer.disconnect();
		}
	}


	observerCallback(entries) {
		const activePage = Store.get().activePage.id;
		if (activePage !== this.props.pageId) {
			return;
		}
		const trackingCategory = activePage === 'successStories' ? 'successStories' : 'jobListings';
		const trackingAction = activePage === 'successStories' ? 'success-story-view' : 'job-listing-view';
		const trackingLabel = this.props.data.key;
		entries.forEach(e => {
			if (e.isIntersecting && !this.state.tracked) {
				Store.emit('POWSTER_GA_EVENT_TRACK', trackingAction, trackingCategory, trackingLabel);
				this.setState({ tracked: true });
			}
		});
	}


	onContentClick(e) {
		const innerHTML = e.target.innerHTML.toLowerCase();
		const nodeName = e.target.nodeName.toLowerCase();
		let label;
		const options = {};
		const { data } = this.props;

		if (innerHTML === 'apply' && nodeName === 'a') {
			label = 'button-click_apply';
		}
		if (innerHTML === 'email resume' && nodeName === 'a') {
			label = 'button-click_emailResume';
		}
		
		if (label) {
			options.job_listing_id = data?.key;
			options.job_category = data?.category;
			options.employer = data?.employer;
			if (!options.employer) {
				let parsedEmployer = data?.body?.match(/<h2>([^|]+)\|{1}/);
				if (parsedEmployer?.[1]) {
					options.employer = parsedEmployer[1].trim();
				}
			}
			Store.emit('POWSTER_GA_EVENT_TRACK', 'button-click', 'jobsButtons', label, options);
		}
	}

	renderBodyImage() {
		let data = this.props.data;
		let img = <img class={this.s.bodyImage} src={data.imageSrc} />;
		if (data.imageLink) {
			img = (
				<Link class={this.s.imageLink} href={data.imageLink} target="_blank">
					<img class={this.s.bodyImage} src={data.imageSrc}  alt={data.imageAlt} />
				</Link>
			);
		} else {
			img = (
				<div class={this.s.imageLink}>
					<img class={this.s.bodyImage} src={data.imageSrc}  alt={data.imageAlt} />
				</div>
			);
		}
		return img;
	}

	render(props) {
		const base = super.render(props);
		const articleContent = findInVNode(base, `.${s.content}`);
		if (articleContent) {
			articleContent.attributes.onClickCapture = this.onContentClick;
		}
		return base;
	}
}
